import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '../lib/api';

export const API_KEYS_QUERY_KEY = ['apiKeys'] as const;

/** Live API keys on the signed-in account. Revoked keys are omitted server-side. */
export function useApiKeys(options: { enabled?: boolean } = {}) {
    return useQuery({
        queryKey: API_KEYS_QUERY_KEY,
        queryFn: () => api.listKeys(),
        staleTime: 30_000,
        enabled: options.enabled ?? true,
    });
}

/**
 * Issues a key and returns the full secret in the mutation result, the only
 * place it's ever visible. The caller is responsible for showing it once and
 * not letting the value outlive that render.
 */
export function useCreateApiKey() {
    const client = useQueryClient();

    return useMutation({
        mutationFn: (name: string) => api.createKey(name),
        onSuccess: () => client.invalidateQueries({ queryKey: API_KEYS_QUERY_KEY }),
    });
}

export function useRevokeApiKey() {
    const client = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => api.revokeKey(id),
        onSuccess: () => client.invalidateQueries({ queryKey: API_KEYS_QUERY_KEY }),
    });
}
